export default __webpack_public_path__ + "static/min-duration-dark-mode-d74a3135a543c64ab19ba0496bfbaccc.png";